import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LabelComponent from "pages/profile/common/label";
import { ReactComponent as EditIcon } from "images/profile/edit-icon.svg";
import { ReactComponent as AddCircleIcon } from "images/auth/add-circle.svg";

function BankDetailsInformation({
  onEditClick = () => {},
  isShowEditIcon = false,
}) {
  const [t] = useTranslation();
  const [isEditShowEditOnHover, setShowEditOnHover] = useState(false);
  const userDetails = useSelector((state) => state.userDetails || {});

  const isShowAddIcon = !userDetails?.bankDetails?.companyName;

  const user = useSelector((state) => state.user || {});
  const isLoggedInByMagicLink = user?.isAdmin ?? false;

  return (
    <div
      id="bankDetailsSection"
      className={`flex p-[24px] flex-col gap-[12px] self-stretch cursor-pointer ${
        isEditShowEditOnHover && !isShowAddIcon && !isLoggedInByMagicLink
          ? "bg-[#F3F5F7]"
          : ""
      }`}
      onMouseEnter={() => {
        if (!isLoggedInByMagicLink) {
          setShowEditOnHover(true);
        }
      }}
      onMouseLeave={() => setShowEditOnHover(false)}
    >
      <div className="flex justify-between items-center self-stretch">
        <div className="text-[#1D1B22] font-semibold text-[24px]">
          {t("bankDetails")}
        </div>
        {isShowEditIcon && !isShowAddIcon && !isLoggedInByMagicLink && (
          <EditIcon
            className={`cursor-pointer ${
              isEditShowEditOnHover ? "visible" : "invisible"
            }`}
            onClick={() => {
              if (!isLoggedInByMagicLink) {
                onEditClick();
              }
            }}
          />
        )}
      </div>

      {isShowAddIcon && !isLoggedInByMagicLink && (
        <div
          className="flex gap-[8px] cursor-pointer max-w-[175px]"
          onClick={() => {
            if (!isLoggedInByMagicLink) {
              onEditClick();
            }
          }}
        >
          <AddCircleIcon />
          <div className="text-primary font-bold text-[16px] not-italic">
            {t("addBankDetails")}
          </div>
        </div>
      )}
      {!isShowAddIcon && (
        <div className="flex flex-wrap gap-[20px]">
          <LabelComponent
            title={t("companyName")}
            subTitle={`${userDetails?.bankDetails?.companyName ?? "-"}`}
          />
          <LabelComponent
            title={t("accountHolderName")}
            subTitle={`${userDetails?.bankDetails?.accountName ?? "-"}`}
          />
          <LabelComponent
            title={t("bankName")}
            subTitle={`${userDetails?.bankDetails?.bankName ?? "-"}`}
          />
          <LabelComponent
            title={t("accountNumber")}
            subTitle={`${userDetails?.bankDetails?.accountNumber ?? "-"}`}
          />
          <LabelComponent
            title={t("accountCurrency")}
            subTitle={`${userDetails?.bankDetails?.accountCurrency ?? "-"}`}
          />
          <LabelComponent
            title={t("swiftCode")}
            subTitle={`${userDetails?.bankDetails?.swiftCode ?? "-"}`}
          />
          <LabelComponent
            title={t("iban")}
            subTitle={`${userDetails?.bankDetails?.iban ?? "-"}`}
          />
          <LabelComponent
            title={t("bankAddress")}
            subTitle={`${userDetails?.bankDetails?.bankAddress ?? "-"}`}
          />
          <LabelComponent
            title={t("routingCode")}
            subTitle={`${userDetails?.bankDetails?.routingCode ?? "-"}`}
          />
          <LabelComponent
            title={t("sortCode")}
            subTitle={`${userDetails?.bankDetails?.sortCode ?? "-"}`}
          />
        </div>
      )}
    </div>
  );
}

BankDetailsInformation.propTypes = {
  onEditClick: PropTypes.func,
  isShowEditIcon: PropTypes.bool,
};

export default BankDetailsInformation;
